import { UserConditionTypeModel } from './userConditionTypeModel';

export class UserConditionModel {
    public userConditionId: number;
    public userId: number;
    public userConditionTypes: Array<UserConditionTypeModel>;
    public userConditionTypeId: number;
    public userConditionUnit: string;
    public personalCondition: string;
    public isSystemType: boolean;
    public label?: string;
    public isVisible: boolean;
    public personalMinValue: number;
    public personalMaxValue: number;
}